<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <div class="srchTop_wrap srch_mypage">
            <article class="srch_detail">
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.MENU') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="BOARD_TYPE1"
                                    name="BOARD_TYPE1"
                                    v-model="BOARD_TYPE1"
                                    class="slt_white w100p"
                                    @change="changeBoardType1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType1List.length > 0"
                                            v-for="item in boardType1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="BOARD_TYPE2"
                                    name="BOARD_TYPE2"
                                    v-model="BOARD_TYPE2"
                                    class="slt_white w100p"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType2List.length > 0"
                                            v-for="item in boardType2List"
                                            :key="item.code"
                                            :value="item.code"
                                            :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_3">
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD1"
                                        v-model="PRD_CATEGORY_CD1"
                                        @change="changeCategory1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList1.length > 0"
                                            v-for="item in categoryComboList1"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD2"
                                        v-model="PRD_CATEGORY_CD2"
                                        @change="changeCategory2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList2.length > 0"
                                            v-for="item in categoryComboList2"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD3"
                                        v-model="PRD_CATEGORY_CD3"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList3.length > 0"
                                            v-for="item in categoryComboList3"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_input">
                    <dt>{{ $t('FIELD.GLOBAL.ADDED.ON') }}</dt>
                    <dd data-input-type="date">
                        <fieldset class="ui_fieldset">
                            <span class="date-wrap">
                                <label>
                                    <input id="fromDate" type="text" class="date_input w100p" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                    <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="from-picker-container" style="margin-top: -1px;"/>
                            </span>
                            <em class="txt_space"></em>
                            <span class="date-wrap">
                                <label>
                                    <input id="toDate" type="text" class="date_input w100p" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                    <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                </label>
                                <div id="to-picker-container" style="margin-top: -1px;"/>
                            </span>
                        </fieldset>
                    </dd>
                </dl>
                <!-- 200714수정(input 하나 일때 클래스추가)-->
                <dl class="dl_search full_input">
                    <dt>{{ $t('FIELD.GLOBAL.SUBJECT') }}</dt>
                    <dd data-input-type="input">
                        <input  type="text"
                                class="text_input w100p"
                                maxlength="200"
                                :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH')"
                                v-model.trim="searchSubject"
                                @keyup.enter.stop="handleSearch"
                                v-clearable
                        />
                        <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                    </dd>
                </dl>
                <!-- 200714수정 S -->
                <span class="srch_mypage_btn">
                    <a href="javascript:" class="btn_srch" @click="handleSearch">{{ $t('FIELD.GLOBAL.SEARCH') }}</a>
                </span>
            </article>
        </div>

        <!-- Grid -->
        <div class="grid_wrap" v-resize="setGridResizeColumn">
            <favorite-grid
                :gridId="gridId"
                :ref="gridId"
                :columns="columns"
                :data="gridData"
                :options="options"
                :pageOptions="pageOptions"
                :isTotalCount="true"
                :click="contentClick"
                @grid-total-count="setTotalCount"
            />
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="movePage"
                />
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import moment                               from 'moment';
import resize                               from 'vue-resize-directive'
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

import FavoriteContentsListGrid             from './FavoriteContentsListGrid';
import KnowledgeContentsPopup               from '~vb/knowledge/popup/KnowledgeContentsPopup';

require('moment-jdateformatparser');

const MAX_DATE = new Date(2999,12,31),
      MIN_DATE = new Date(1900,1,1);

// list 에서 쓰이는 아이콘 이미지 경로
const ICON_IMG = {
    favorite:   { on: '/static/images/ico_favorite_on.png', off: '/static/images/ico_favorite_off.png' }
};

// ToastGrid image icon renderer
class CustomImageRenderer {
    constructor(props) {
        const el = document.createElement('img');
        const { imgType } = props.columnInfo.renderer.options;
        let onImg = '', offImg = '';

        // renderer by column type
        switch(imgType) {
            case 'favorite' : onImg = ICON_IMG.favorite.on,     offImg = ICON_IMG.favorite.off;     break;
            case 'file'     : onImg = ICON_IMG.file.on,         offImg = ICON_IMG.file.off;         break;
            default         : break;
        };

        let isImg = false;
        if(!SDLUtil.isNull(props.value)) {
            if(props.value === 'Y' || props.value > 0 || props.value === true) isImg = true;
        }

        el.src = isImg ? onImg : offImg;
        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

export default {
    name: 'FavoriteContentsList',
    data() {
    	return {
            pageTitle: '',

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2

            PRD_CATEGORY_CD1: '',       // Category 1
            PRD_CATEGORY_CD2: '',       // Category 2
            PRD_CATEGORY_CD3: '',       // Category 3
            categoryComboList1: [],     // Category 1 List
            categoryComboList2: [],     // Category 2 List
            categoryComboList3: [],     // Category 3 List
            qCategory1: '',             // Quick Category Value 1
            qCategory2: '',             // Quick Category Value 2
            qCategory3: '',             // Quick Category Value 3

            rangePicker: null,

            searchSubject: '',            // Subject

            gridId: 'FavoriteContentsListGrid',
            columns: [],
            options: {},
            pageOptions: {},
            gridData: [],

            totalCount: 0,
            pageNo: 1,
            currentPage: 1,
            perPage: localStorage.getItem('listRows') ? Number(localStorage.getItem('listRows')) : 10
    	}
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getUserInfo()           { return SDLUtil.getLoginedUserInfo() || {}; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getScrapWorkCode()      { return MenuUtil.getScrapWorkCode(); },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },
        getSelCategory1()       { return (!SDLUtil.isNull(this.qCategory1)) ? this.qCategory1 : this.PRD_CATEGORY_CD1 || ''; },
        getSelCategory2()       { return (!SDLUtil.isNull(this.qCategory2)) ? this.qCategory2 : this.PRD_CATEGORY_CD2 || ''; },
        getSelCategory3()       { return (!SDLUtil.isNull(this.qCategory3)) ? this.qCategory3 : this.PRD_CATEGORY_CD3 || ''; },
        getReSearch()           { return this.$route.query.reSearch || 'N'; },
        getPageNo()             { return this.pageNo; },
    },
    directives: { resize },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'sdl-pagination'    : SDLPagination,
        'favorite-grid'     : FavoriteContentsListGrid,
    },
    methods: {
        // 처음 로딩 시
        initLoad() {
            SDLUtil.showLoadingBar(true);
            // 그리드 컬럼 세팅
            this.columns = this.getDynamicCols();
            // 게시판 타입 1 로드
            this.setBoardType1().then(() => { this.setBoardType2(); });
            // 초기 카테고리1 리스트 로드
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.categoryComboList1 = data;
            });

            SDLUtil.showLoadingBar(false);

            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        // Board1 setting
        setBoardType1() {
            this.getCodeComboList(this.getUserCorpCd, "BOARD_TYPE1").then(data => {
                this.BOARD_TYPE1 = this.getSelBoardType1;
                this.boardType1List = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // Board2 setting
        setBoardType2() {
            this.getCodeComboList(this.getSelBoardType1, "BOARD_TYPE2").then(data => {
                this.BOARD_TYPE2 = this.getSelBoardType2;
                this.boardType2List = data;
            });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                    this.BOARD_TYPE2    = '';
                });
            }
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList(this.getSelCategory1, "ADM_CATEGORY_B").then(data => {
                this.PRD_CATEGORY_CD1 = this.getSelCategory1;
                this.categoryComboList2 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 두번째 카테고리 설정
        setCategory2() {
            this.getCodeComboList(this.getSelCategory2, "ADM_CATEGORY_C").then(data => {
                this.PRD_CATEGORY_CD2 = this.getSelCategory2;
                this.categoryComboList3 = data;
                this.PRD_CATEGORY_CD3 = this.getSelCategory3;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2   = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3   = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MENU'), name: 'BOARD_TYPE', align: 'left', width: this.getColumnSize(20), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'), name: 'PRD_CATEGORY_NM', align: 'left', width: this.getColumnSize(25), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'), name: 'KNOWLEDGE_TITLE', align: 'left', width: this.getColumnSize(25), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.ON'), name: 'REG_DT', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.REGISTERED.BY'), name: 'REG_USER_NM', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.HIT'), name: 'HIT_COUNT', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: ' ', name: 'FAVORITE', align: 'center', width: 50, renderer: { type: CustomImageRenderer, options: { imgType : 'favorite' } } },
                { header: 'FAVORITE_ID', name: 'FAVORITE_ID', hidden: true },
                { header: 'KNOWLEDGE_ID', name: 'KNOWLEDGE_ID', hidden: true },
                { header: 'BOARD_ID', name: 'BOARD_ID', hidden: true },
                { header: 'WORK_CD', name: 'WORK_CD', hidden: true },
            ];
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor((gridWrapSize - 50) / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('fav-grid-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        // 페이지 이동
        movePage(pageNo) {
            this.currentPage = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            this.totalCount = totCnt;
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            this.currentPage = page;
        },

        // Search Parameter setting
        setSearchParameter() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');

            return {
                BOARD_TYPE1: this.getSelBoardType1,
                BOARD_TYPE2: this.getSelBoardType2,
                categoryA: this.PRD_CATEGORY_CD1 || '',
                categoryB: this.PRD_CATEGORY_CD2 || '',
                categoryC: this.PRD_CATEGORY_CD3 || '',
                searchSubject: this.searchSubject,
                addedDateStart: this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).formatWithJDF(mFormat) : '',
                addedDateEnd: this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(mFormat) : '',
                ORDER_COLUMN: this.ORDER_COLUMN || '',
                ORDER_ASC: this.ORDER_ASC || '',
                page: this.getPageNo
            }
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!SDLUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 페이지 조회
        handlePageSearch(pageNo){
            if(pageNo !== null && pageNo != "") {
                this.pageNo = pageNo;
                this.handleSearch();

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 조회
        handleSearch() {
            // Call KnowledgeListGrid.vue > loadData method
            EventBus.$emit('fav-grid-search', this.setSearchParameter());
        },
        // 재조회
        reSearch(pageNo) {
            // this.setCategoryParam(boardParam.searchParams);
            this.pageNo = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let KNOWLEDGE_ID = row['KNOWLEDGE_ID'] || '',
                BOARD_ID = row['BOARD_ID'] || '',
                WORK_CD = row['WORK_CD'] || '';

            Vue.$log.info('▶ FavoriteContentsList.vue contentClick event. =>', row, KNOWLEDGE_ID, WORK_CD);

            // 컬럼별 이벤트 실행
            if(colNm === 'FAVORITE') {
                let cVal = 0,
                    imgEl = document.createElement('img'),
                    url = '', fvParams = { workCd: WORK_CD, workCdSeq: KNOWLEDGE_ID };
                if( row['FAVORITE'] > 0 ) {
                    imgEl.src = ICON_IMG.favorite.off, cVal = 0;
                    url = `${SDLUtil.API_URL}/basis/common/scrap/deleteScrap.skp`;
                } else {
                    imgEl.src = ICON_IMG.favorite.on, cVal = 1;
                    url = `${SDLUtil.API_URL}/basis/common/scrap/scrap.skp`;
                }

                return  axios.post( url, qs.stringify(fvParams), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
                    .then(res => {
                        let msg = "";
                        if(cVal > 0) {
                            msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.ADDFAVORITE');
                        } else {
                            msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.REMOVEFAVORITE');
                        }
                        // Notification
                        Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );

                        EventBus.$emit('fav-grid-change-column-element', { rowNo: e.rowKey, colNm: colNm, cEl: imgEl });
                        grid.invoke('setValue', e.rowKey, 'FAVORITE', cVal, false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                    });

            } else {
                const params = { BOARD_ID: BOARD_ID, KNOWLEDGE_ID: KNOWLEDGE_ID };
                return this.$router.push({ name: 'MyFavoriteContentsDetail', query: params });
            }
        },

        // Quick Category Parameter setting
        setQuickCategoryParam(catForm) {
            this.initCategoryParam();
            this.qCategory1 = catForm.searchPRD_CATEGORY_CD1;
            this.qCategory2 = catForm.searchPRD_CATEGORY_CD2;
            this.qCategory3 = catForm.searchPRD_CATEGORY_CD3;

            this.changeCategories();
        },
        // 카테고리 파라미터 초기화
        initCategoryParam() {
            this.qCategory1 = '';
            this.qCategory2 = '';
            this.qCategory3 = '';
            this.PRD_CATEGORY_CD1 = '';
            this.PRD_CATEGORY_CD2 = '';
            this.PRD_CATEGORY_CD3 = '';
            this.categoryComboList1 = [];
            this.categoryComboList2 = [];
            this.categoryComboList3 = [];
        },
        // 모든 카테고리 변경 이벤트, 처음 Mounted 혹은, quick category 를 click 했을 때 호출
        changeCategories() {
            this.setCategory1().then(() => {
                this.setCategory2().then(() => {
                    this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                        this.categoryComboList1 = data;
                    });
                });
            });
        },
    },
    created() {
        this.initLoad().then(() => {
            Vue.$log.info('▶ FavoriteContentsList.vue created.');
            EventBus.$on('page-search',    pageNo   => { this.handlePageSearch(pageNo); });
            EventBus.$on('sort-search',    sortForm => { this.handleSortSearch(sortForm); });
            EventBus.$on('quick-category', catForm  => { this.setQuickCategoryParam(catForm); });
        });
    },
    mounted() {
        // DOM 생성 후 이벤트
        this.$nextTick(() => {
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'years').toDate(),
                (new moment()).toDate()
            );
        });
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('page-search');
        EventBus.$off('sort-search');
        EventBus.$off('quick-category');
    }
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/myFavoriteContents/FavoriteContentsList.vue